import useMoney from '../../../../../hooks/useMoney';
import { useTranslation } from '../../../../translation/TranslationContext';
import { getOrderConditionErrors } from '../../../conditions/orderConditionFieldErrors.utils';
import { useOrderConditionContext } from '../../../contexts/OrderCondition.context';
import { useOrderEditSectionsContext } from '../../../edit/sections/OrderEditSections.context';
import { getBusinessPolicyViolationViews } from '../../../edit/validate/conditions/businessPolicy/businessPolicyViolation.utils';

const useOrderTabsPolicyViolations = () => {
  const { translate } = useTranslation();
  const { formatMoney } = useMoney();
  const { orderConditions } = useOrderConditionContext();
  const {
    productsBusinessPolicyViolations,
    rawConditionErrors,
    openPolicyViolationsModal,
    openPolicyViolationSectionsModal,
  } = useOrderEditSectionsContext();

  const conditionsSections = orderConditions
    .map((condition) => ({
      condition,
      violations: getBusinessPolicyViolationViews({
        errors: getOrderConditionErrors(rawConditionErrors, condition.id),
        translate,
        formatMoney,
      }),
    }))
    .filter(({ violations }) => violations.length);

  return {
    openProductsPolicyViolations: productsBusinessPolicyViolations.length
      ? () => openPolicyViolationsModal(productsBusinessPolicyViolations)
      : undefined,
    openConditionsPolicyViolations: conditionsSections.length
      ? () => openPolicyViolationSectionsModal(conditionsSections)
      : undefined,
  };
};

export default useOrderTabsPolicyViolations;
